import { render, staticRenderFns } from "./SlotsFilters.vue?vue&type=template&id=cf08b924&scoped=true&lang=pug&"
import script from "./SlotsFilters.vue?vue&type=script&lang=js&"
export * from "./SlotsFilters.vue?vue&type=script&lang=js&"
import style0 from "./SlotsFilters.vue?vue&type=style&index=0&id=cf08b924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf08b924",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VContainer,VRadio,VRadioGroup,VRow,VSelect})
